import { render, staticRenderFns } from "./x-button-switch.vue?vue&type=template&id=773338cc&scoped=true&"
import script from "./x-button-switch.vue?vue&type=script&lang=js&"
export * from "./x-button-switch.vue?vue&type=script&lang=js&"
import style0 from "./x-button-switch.vue?vue&type=style&index=0&id=773338cc&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773338cc",
  null
  
)

export default component.exports